package com.example.mystybag.sharedmodels.project.responseModels.reservations

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
class CreateReservationResponseModel(
    val reservationId: Long = 0L,
    val transactionReference    : String = "",
    val checkoutUrl: String = "",
    val paymentUrl: String = "",
    val returnUrl: String = "",
    val cancelUrl: String = "",
    val privateKey: String = "",
    val ipcVersion: String = "",
    val ipcLanguage: String = "",
    val sid: String = "",
    val walletNumber: String = "",
    val amount: String = "",
    val currency: String = "",
    val customerEmail: String = "",
    val cartItems: String = "",
    val article1: String = "",
    val quantity1: String = "",
    val price1: String = "",
    val currency1: String = "",
    val amount1: String = "",
    val article2: String = "",
    val quantity2: String = "",
    val price2: String = "",
    val currency2: String = "",
    val amount2: String = "",
    val customerFirstName: String = "",
    val customerLastName: String = "",
    val customerPhone: String = "",
    val customerCountry: String = "",
    val customerCity: String = "",
) : BaseResponseModel()